import { render, staticRenderFns } from "./UiFilterList.vue?vue&type=template&id=118db3ea"
import script from "./UiFilterList.vue?vue&type=script&lang=js"
export * from "./UiFilterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports